import Scopes from "./Scopes-container";

/**
 * Export the top level component TeamScopes-container
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
export default Scopes;
